import { apiDaInscricao } from "../../../servicos/axios";
import type { ApiAgendamento } from "./buscarAgenda";

export type CancelarAgendamentoPayload = {
  agendamentoId: number;
  justificativa: string;
};

export const cancelarAgendamento = async (
  payload: CancelarAgendamentoPayload
): Promise<ApiAgendamento> => {
  const api = apiDaInscricao();
  const resp = await api.post("/agendamento/Cancelar", payload);
  return resp.data?.agendamento as ApiAgendamento;
};
